export enum Intervals {
	"15minute" = "15minute",
	"1hour" = "1hour",
	"6hour" = "6hour",
	"1day" = "1day",
	"7days" = "7day",
	"1month" = "1month",
}
